// extracted by mini-css-extract-plugin
export var dividerLine = "_6z-3";
export var itemImage = "_6z-9";
export var lightDivider = "_6z-4";
export var modalContent = "_6z-5";
export var modalContentCompact = "_6z-6";
export var productCard = "_6z-a";
export var productImage = "_6z-b";
export var productImageCompact = "_6z-7";
export var productImagePlaceholder = "_6z-c";
export var productImagePlaceholderCompact = "_6z-8";
export var progressBarBackground = "_6z-1";
export var progressBarContainer = "_6z-0";
export var progressBarFill = "_6z-2";